// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/bg-contact.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rassd-root {
  font-family: "Roboto", sans-serif;
  color: #1a2332;
  background: #fff;
  margin: 0;
}

.rassd-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid #eef0f3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5%;
  height: 60px;
}

.rassd-nav__logo {
  display: flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
}

.rassd-nav__logo-text {
  font-size: 18px;
  font-weight: 800;
  color: #1a2332;
  letter-spacing: -0.5px;
}

.rassd-nav__logo-badge {
  background: #000000;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 5px;
  border-radius: 4px;
}

.rassd-nav__links {
  display: flex;
  align-items: center;
  gap: 32px;
}

.rassd-nav__link {
  font-size: 18px;
  color: #000000;
  cursor: pointer;
  background: none;
  border: none;
  font-family: inherit;
  font-weight: 500;
  transition: color 0.2s;
  padding: 0;
}

.rassd-nav__link:hover {
  color: #2563eb;
}

.btn-primary {
  background: #000000;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.2s,
    transform 0.1s;
  font-family: inherit;
}

.btn-primary:hover {
  background: #1d4ed8;
}

.btn-outline {
  background: transparent;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 9px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.2s;
  font-family: inherit;
}

.btn-outline:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.rassd-hero {
  text-align: center;
  padding: 72px 5% 150px;
  background: linear-gradient(0deg, #e5e5e5 0%, #fff 100%);
}

.rassd-hero__title {
  font-size: clamp(28px, 4vw, 44px);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.15;
  letter-spacing: -1px;
  margin: 0 auto 16px;
}

.rassd-hero__subtitle {
  font-size: 15px;
  color: #6b7280;
  max-width: 480px;
  margin: 0 auto 32px;
  line-height: 1.6;
}

.rassd-hero__buttons {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 52px;
  flex-wrap: wrap;
}

.rassd-features {
  padding: 72px 5% 0 5%;
}
#why-newsroom{
  padding-top: 75px;
}
.rassd-section__title {
  font-size: clamp(22px, 3vw, 34px);
  font-weight: 800;
  text-align: center;
  color: #0f172a;
  letter-spacing: -0.5px;
  margin-bottom: 48px;
}
.btn-primary a{
  text-decoration: none;
  color: #fff;
}

.rassd-features__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));
  gap: 24px;
}

.rassd-feature-card {
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #eef0f3;
  background-color: #f2f2f7;
  transition:
    box-shadow 0.2s,
    border-color 0.2s;
  cursor: default;
}

.rassd-feature-card:hover {
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.1);
  border-color: #bfdbfe;
}

.rassd-feature-card__icon {
  color: #000000;
  margin-bottom: 12px;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #e5e5e5;
  display: inline-flex;
  padding: 10px;
}

.rassd-feature-card__title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 8px;
}

.rassd-feature-card__desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.55;
}

.rassd-why__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  max-width: 960px;
  margin: 30px auto;
}

.rassd-why__title {
  font-size: clamp(24px, 3vw, 36px);
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.5px;
  line-height: 1.2;
  margin-bottom: 10px;
}

.rassd-why__subtitle {
  font-size: 14px;
  color: #6b7280;
}

.rassd-why__item {
  display: flex;
  gap: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 1px;
  margin-bottom: 28px;
  align-items: flex-start;
  padding: 20px 10px;
}
.rassd-mockup {
  text-align: center;
}
.rassd-mockup-image {
  width: 100%;
  max-width: 1100px;
  height: auto;
  background-color: #f2f2f7;
  padding: 10px;
  border-radius: 16px;
  margin-top: -170px;
  box-sizing: border-box;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.rassd-why__num {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #000000;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.rassd-why__item-title {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 4px;
}

.rassd-why__item-desc {
  font-size: 13px;
  color: #6b7280;
  line-height: 1.55;
}

.rassd-contact {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 80px 5%;
  background-color: #f7f7f7;
}

.rassd-contact__inner {
  max-width: 640px;
  margin: 0 auto;
}

.rassd-contact__title {
  font-size: clamp(26px, 3vw, 38px);
  font-weight: 800;
  text-align: center;
  color: #0f172a;
  letter-spacing: -0.5px;
  margin: 0;
  padding: 0;
}

.rassd-contact__subtitle {
  text-align: center;
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 40px;
}

/* ── FORM ─────────────────────────────────── */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.form-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.form-input {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  color: #1a2332;
  outline: none;
  font-family: inherit;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
  background: #fff;
}

.form-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-input--error {
  border-color: #ef4444;
}

.form-error {
  font-size: 11px;
  color: #ef4444;
  margin-top: 4px;
}

.form-textarea {
  padding: 10px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 14px;
  color: #1a2332;
  outline: none;
  font-family: inherit;
  min-height: 120px;
  resize: vertical;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}

.form-textarea:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.form-textarea--error {
  border-color: #ef4444;
}

.form-submit {
  width: 100%;
  padding: 13px;
  background: #0f172a;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.2s;
  font-family: inherit;
  letter-spacing: 0.2px;
}

.form-submit:hover:not(:disabled) {
  background: #1e3a8a;
}

.form-submit:disabled {
  opacity: 0.8;
  cursor: not-allowed;
}

/* ── SUCCESS ──────────────────────────────── */
.success-box {
  text-align: center;
  padding: 48px 24px;
  background: #f0fdf4;
  border-radius: 12px;
  border: 1px solid #bbf7d0;
}

.success-box__emoji {
  font-size: 40px;
  margin-bottom: 12px;
}

.success-box__title {
  font-size: 20px;
  font-weight: 700;
  color: #15803d;
  margin-bottom: 8px;
}

.success-box__desc {
  color: #166534;
  font-size: 14px;
}

/* ── FOOTER ───────────────────────────────── */
.rassd-footer {
  padding: 20px 5%;
  text-align: center;
  border-top: 1px solid #eef0f3;
}

.rassd-footer__text {
  font-size: 14px;
  color: #000000;
  font-weight: 400;
  margin: 0;
}
@media (max-width: 768px) {
  .rassd-features__grid,
  .rassd-why__grid,
  .form-row {
    grid-template-columns: initial;
  }
}
`, "",{"version":3,"sources":["webpack://./src/RassdLanding.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;EACjC,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,qCAAqC;EACrC,2BAA2B;EAC3B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;kBAEgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB;;qBAEmB;EACnB,eAAe;AACjB;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yDAAsD;EACtD,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB;;mBAEiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB;;mBAEiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;AACA;EACE;;;IAGE,8BAA8B;EAChC;AACF","sourcesContent":[".rassd-root {\n  font-family: \"Roboto\", sans-serif;\n  color: #1a2332;\n  background: #fff;\n  margin: 0;\n}\n\n.rassd-nav {\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(12px);\n  border-bottom: 1px solid #eef0f3;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 5%;\n  height: 60px;\n}\n\n.rassd-nav__logo {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  text-decoration: none;\n}\n\n.rassd-nav__logo-text {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1a2332;\n  letter-spacing: -0.5px;\n}\n\n.rassd-nav__logo-badge {\n  background: #000000;\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 2px 5px;\n  border-radius: 4px;\n}\n\n.rassd-nav__links {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n}\n\n.rassd-nav__link {\n  font-size: 18px;\n  color: #000000;\n  cursor: pointer;\n  background: none;\n  border: none;\n  font-family: inherit;\n  font-weight: 500;\n  transition: color 0.2s;\n  padding: 0;\n}\n\n.rassd-nav__link:hover {\n  color: #2563eb;\n}\n\n.btn-primary {\n  background: #000000;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    background 0.2s,\n    transform 0.1s;\n  font-family: inherit;\n}\n\n.btn-primary:hover {\n  background: #1d4ed8;\n}\n\n.btn-outline {\n  background: transparent;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 9px 20px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.btn-outline:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n}\n\n.rassd-hero {\n  text-align: center;\n  padding: 72px 5% 150px;\n  background: linear-gradient(0deg, #e5e5e5 0%, #fff 100%);\n}\n\n.rassd-hero__title {\n  font-size: clamp(28px, 4vw, 44px);\n  font-weight: 800;\n  color: #0f172a;\n  line-height: 1.15;\n  letter-spacing: -1px;\n  margin: 0 auto 16px;\n}\n\n.rassd-hero__subtitle {\n  font-size: 15px;\n  color: #6b7280;\n  max-width: 480px;\n  margin: 0 auto 32px;\n  line-height: 1.6;\n}\n\n.rassd-hero__buttons {\n  display: flex;\n  gap: 12px;\n  justify-content: center;\n  margin-bottom: 52px;\n  flex-wrap: wrap;\n}\n\n.rassd-features {\n  padding: 72px 5% 0 5%;\n}\n#why-newsroom{\n  padding-top: 75px;\n}\n.rassd-section__title {\n  font-size: clamp(22px, 3vw, 34px);\n  font-weight: 800;\n  text-align: center;\n  color: #0f172a;\n  letter-spacing: -0.5px;\n  margin-bottom: 48px;\n}\n.btn-primary a{\n  text-decoration: none;\n  color: #fff;\n}\n\n.rassd-features__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(20%, 1fr));\n  gap: 24px;\n}\n\n.rassd-feature-card {\n  padding: 24px;\n  border-radius: 8px;\n  border: 1px solid #eef0f3;\n  background-color: #f2f2f7;\n  transition:\n    box-shadow 0.2s,\n    border-color 0.2s;\n  cursor: default;\n}\n\n.rassd-feature-card:hover {\n  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.1);\n  border-color: #bfdbfe;\n}\n\n.rassd-feature-card__icon {\n  color: #000000;\n  margin-bottom: 12px;\n  background-color: #fff;\n  border-radius: 4px;\n  border: 1px solid #e5e5e5;\n  display: inline-flex;\n  padding: 10px;\n}\n\n.rassd-feature-card__title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 8px;\n}\n\n.rassd-feature-card__desc {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.55;\n}\n\n.rassd-why__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 48px;\n  max-width: 960px;\n  margin: 30px auto;\n}\n\n.rassd-why__title {\n  font-size: clamp(24px, 3vw, 36px);\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.5px;\n  line-height: 1.2;\n  margin-bottom: 10px;\n}\n\n.rassd-why__subtitle {\n  font-size: 14px;\n  color: #6b7280;\n}\n\n.rassd-why__item {\n  display: flex;\n  gap: 16px;\n  border: 1px solid #e5e5e5;\n  border-radius: 1px;\n  margin-bottom: 28px;\n  align-items: flex-start;\n  padding: 20px 10px;\n}\n.rassd-mockup {\n  text-align: center;\n}\n.rassd-mockup-image {\n  width: 100%;\n  max-width: 1100px;\n  height: auto;\n  background-color: #f2f2f7;\n  padding: 10px;\n  border-radius: 16px;\n  margin-top: -170px;\n  box-sizing: border-box;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.rassd-why__num {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #000000;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.rassd-why__item-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin-bottom: 4px;\n}\n\n.rassd-why__item-desc {\n  font-size: 13px;\n  color: #6b7280;\n  line-height: 1.55;\n}\n\n.rassd-contact {\n  background-image: url(\"/public/images/bg-contact.png\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  padding: 80px 5%;\n  background-color: #f7f7f7;\n}\n\n.rassd-contact__inner {\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.rassd-contact__title {\n  font-size: clamp(26px, 3vw, 38px);\n  font-weight: 800;\n  text-align: center;\n  color: #0f172a;\n  letter-spacing: -0.5px;\n  margin: 0;\n  padding: 0;\n}\n\n.rassd-contact__subtitle {\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n  margin-bottom: 40px;\n}\n\n/* ── FORM ─────────────────────────────────── */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n}\n\n.form-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 6px;\n}\n\n.form-input {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 14px;\n  color: #1a2332;\n  outline: none;\n  font-family: inherit;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n  background: #fff;\n}\n\n.form-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-input--error {\n  border-color: #ef4444;\n}\n\n.form-error {\n  font-size: 11px;\n  color: #ef4444;\n  margin-top: 4px;\n}\n\n.form-textarea {\n  padding: 10px 14px;\n  border-radius: 8px;\n  border: 1px solid #d1d5db;\n  font-size: 14px;\n  color: #1a2332;\n  outline: none;\n  font-family: inherit;\n  min-height: 120px;\n  resize: vertical;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n\n.form-textarea:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.form-textarea--error {\n  border-color: #ef4444;\n}\n\n.form-submit {\n  width: 100%;\n  padding: 13px;\n  background: #0f172a;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.2s;\n  font-family: inherit;\n  letter-spacing: 0.2px;\n}\n\n.form-submit:hover:not(:disabled) {\n  background: #1e3a8a;\n}\n\n.form-submit:disabled {\n  opacity: 0.8;\n  cursor: not-allowed;\n}\n\n/* ── SUCCESS ──────────────────────────────── */\n.success-box {\n  text-align: center;\n  padding: 48px 24px;\n  background: #f0fdf4;\n  border-radius: 12px;\n  border: 1px solid #bbf7d0;\n}\n\n.success-box__emoji {\n  font-size: 40px;\n  margin-bottom: 12px;\n}\n\n.success-box__title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #15803d;\n  margin-bottom: 8px;\n}\n\n.success-box__desc {\n  color: #166534;\n  font-size: 14px;\n}\n\n/* ── FOOTER ───────────────────────────────── */\n.rassd-footer {\n  padding: 20px 5%;\n  text-align: center;\n  border-top: 1px solid #eef0f3;\n}\n\n.rassd-footer__text {\n  font-size: 14px;\n  color: #000000;\n  font-weight: 400;\n  margin: 0;\n}\n@media (max-width: 768px) {\n  .rassd-features__grid,\n  .rassd-why__grid,\n  .form-row {\n    grid-template-columns: initial;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
